import { render, staticRenderFns } from "./ExportHistory.vue?vue&type=template&id=55a14369&scoped=true&lang=pug&"
import script from "./ExportHistory.vue?vue&type=script&lang=js&"
export * from "./ExportHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a14369",
  null
  
)

export default component.exports